exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discounts{display:flex;background:#fff;padding-top:20px;padding-bottom:20px}.Discounts .actions{margin-bottom:20px}.Discounts .actions-table{display:flex;align-items:center;flex-direction:row;color:#00adff}.Discounts .actions-table .far{margin-right:10px;cursor:pointer}.Discounts .btn-primary{height:32px;background-color:#fff;border:1px solid #00adff;color:#00adff;padding:0 10px;border-radius:25px;text-transform:uppercase;display:flex;align-items:center;text-align:center;cursor:pointer}.Discounts .btn-primary:hover{color:#fff;background-color:#00adff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/AdminPanel/Discounts/style.scss
// module id = 4460
// module chunks = 0